import loadable from "@loadable/component";
import { PageLoader } from "GlobalComponent/PageLoader";
import { Pages } from "GlobalEnum/NewPage";
import { page } from "GlobalEnum/Page";
import React from "react";
import { Route } from "react-router-dom";
import { MAKE_ENDPOINT } from "../constants/index";

const Make = loadable(
  () =>
    import(/* webpackChunkName: "make-desktop" */ "../containers/Make.desktop"),
  {
    fallback: <PageLoader />,
  }
);

export const MakeRoute = (
  <Route
    exact
    path={MAKE_ENDPOINT}
    render={props => {
      return (
        <Make
          {...props}
          pageId={page.MAKE_PAGE_DESKTOP.id}
          newPageId={Pages.MAKE_PAGE.id}
        />
      );
    }}
  />
);
